import React from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const Badge = ({ className, tag, label, icon, size, color, orientation }) => {
  return (
    <S.BadgeWrapper className={className} orientation={orientation}>
      {icon && <S.BadgeIcon name={icon} size={size} />}
      <S.BadgeLabel as={tag} color={color}>
        {label}
      </S.BadgeLabel>
    </S.BadgeWrapper>
  )
}

Badge.defaultProps = {
  size: 32,
  color: 'neutral500',
  orientation: 'horizontal',
  tag: 'span'
}

Badge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  tag: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
}

export default Badge
